"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduce = reduce;

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/cjs/reducers/stateId.js
// module id = 1217
// module chunks = 0